const stateManager = require('../../utils/state/stateManager');
const constants = require('../../utils/domain/constants');
const localizationUtils = require('../../utils/localization/localizationUtils');


module.exports.createPaymentIntent = function(amount, saleId)
{
    const paymentCurrency = localizationUtils.getCurrency();

    const onlinePaymentConfiguration = stateManager.getStore().getState().onlinePaymentConfiguration;

    if(onlinePaymentConfiguration.paymentProvider === constants.WebPaymentProviders.stripeOverPhone)
    {
        const { payoutStoreId, transactionPercentageFee, transactionFixedFee, transactionTaxRate, connectAccountId } = onlinePaymentConfiguration;

        let feeAmount = onlinePaymentConfiguration.transactionFixedFee;
        feeAmount = feeAmount + (amount * onlinePaymentConfiguration.transactionPercentageFee)/100;
        feeAmount = ((feeAmount * 100).toFixed(0) / 100);
        
        const transactionTax = (feeAmount * transactionTaxRate/ 100).toFixed(2) * 1
        feeAmount += transactionTax;

        const transfer_data = {};
        transfer_data.destination = onlinePaymentConfiguration.connectAccountId;

    
        var metaData = {};
        metaData.flipdish_store_id = payoutStoreId;
        metaData.flipdish_fee_percent = transactionPercentageFee;
        metaData.flipdish_fee_fixed = transactionFixedFee;
        metaData.transaction_tax_rate = transactionTaxRate;
        metaData.transaction_tax_amount = transactionTax;
        metaData.pos_sale_id = saleId;
        metaData.pos_tip_amount = "0.0";

        const paymentIntent = {
            amount: (amount * 100).toFixed(0),
            currency: paymentCurrency,
            capture_method: 'automatic',
            on_behalf_of: connectAccountId,
            application_fee_amount: (feeAmount * 100).toFixed(0),
            transfer_data,
            metadata: metaData
        }

        return paymentIntent;
    }

    if(onlinePaymentConfiguration.paymentProvider === constants.WebPaymentProviders.stripe)
    {
        const paymentIntent = {
            amount: (amount * 100).toFixed(0),
            currency: paymentCurrency,
            capture_method: 'automatic',
        }

        return paymentIntent
    }

    return null;
}